import { FILTER_MESSAGES, FiltersMessages } from "../../inputs/filters.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../../layout/sidebar";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../../action-buttons.messages";

export type CampaignLogsMessages = SidebarMessages &
  FiltersMessages &
  ActionButtonMessages & {
    // Page messages
    pageTitle: string;
    breadCrumbTitle: string;

    // Error messages
    errorToLoadLogs: string;
    noLogsFoundError: string;
    noLogsFoundDescription: string;
    noLogsFoundAlt: string;

    // Table column messages
    expandColumn: string;
    scheduleDate: string;
    statusColumn: string;
    clientColumn: string;
    phoneColumn: string;
    errorMessageColumn: string;
    rowsPerPage: string;

    // Filter messages
    allOption: string;
    status: string;
    contactName: string;
    contactPhone: string;
    selectStatusPlaceholder: string;
    clearFilterButton: string;

    // Status messages
    statusSent: string;
    statusRead: string;
    statusClicked: string;
    statusFailed: string;
    statusDelivered: string;
    statusUnknown: string;
    unknownContactName: string;
    phoneNotProvided: string;
    noError: string;
  };

export const CAMPAIGN_LOG_MESSAGES: CampaignLogsMessages = {
  ...FILTER_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,

  // Page messages
  pageTitle: "Logs da Campanha",
  breadCrumbTitle: "Estatísticas",

  // Error messages
  errorToLoadLogs: "Erro ao carregar logs",
  noLogsFoundError: "Nenhum log encontrado",
  noLogsFoundDescription: "Não foram encontrados logs para esta campanha no período selecionado.",
  noLogsFoundAlt: "Nenhum log encontrado",

  // Table column messages
  expandColumn: "Expandir",
  scheduleDate: "Data Agendada",
  statusColumn: "Status",
  clientColumn: "Cliente",
  phoneColumn: "Celular",
  errorMessageColumn: "Mensagem de Erro",
  rowsPerPage: "Linhas por página",

  // Filter messages
  allOption: "Todos",
  status: "Status",
  contactName: "Nome do Contato",
  contactPhone: "Telefone do Contato",
  selectStatusPlaceholder: "Selecione um status",
  clearFilterButton: "Limpar filtros",

  // Status messages
  statusSent: "Enviado",
  statusRead: "Lido",
  statusClicked: "Clicado",
  statusFailed: "Falhou",
  statusDelivered: "Entregue",
  statusUnknown: "Status Desconhecido",
  unknownContactName: "Nome Desconhecido",
  phoneNotProvided: "Telefone não fornecido",
  noError: "Sem erro",
};
